import type { SpaceProvider } from '@root/types';
import routes from '@root/routes';
import s from './SpaceProviderInfo.module.less';

interface Props {
  spaceProvider: SpaceProvider;
}
const SpaceProviderInfo = ({ spaceProvider }: Props) => {
  const shouldLinkToSpaceProviderPage = spaceProvider.slug;
  const Wrapper = shouldLinkToSpaceProviderPage ? 'a' : 'span';
  const wrapperProperties = spaceProvider.slug
    ? { href: routes.landlords(spaceProvider.slug) }
    : {};

  return (
    <div className={s.container} data-testid="basic-building-space-provider-info">
      <Wrapper {...wrapperProperties}>
        <img
          className={s.logo}
          alt={spaceProvider.logo.description}
          src={spaceProvider.logo.path}
          data-testid="basic-building-space-provider-logo"
        />
      </Wrapper>
      <div className={s.name} data-testid="basic-building-space-provider-name">
        {/* eslint-disable react/jsx-no-literals */}
        <Wrapper {...wrapperProperties}>{spaceProvider.name}</Wrapper>
        {/* eslint-enable react/jsx-no-literals */}
      </div>
    </div>
  );
};

export default SpaceProviderInfo;
